import * as yup from 'yup';
import { EmailValidation } from 'helpers/validations';

const ForgotPasswordFormValidation = yup.object().shape({
  name: EmailValidation(),
});
export default ForgotPasswordFormValidation;
